class CartCustomRemove extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', (event) => {
            event.preventDefault();
            const variantId = this.getAttribute('data-quantity-variant-id');
            const line = parseInt(this.getAttribute('data-index'), 10);
            const cart = this.closest('custom-cart');
            cart.updateQuantity(variantId, 0, Number.isFinite(line) ? line : null)
                .then(() => cart.refreshCartPartials())
                .catch(err => console.error('Remove item error', err));
        });
    }
}

customElements.define('cart-custom-remove', CartCustomRemove);

class CustomCart extends HTMLElement {
    constructor() {
        super();

        this._updateTimer = null;
        this._adding = false;

        this.addEventListener('change', (e) => {
            const quantityInput = e.target.closest('input[name="updates[]"]');
            if (!quantityInput) return;

            const quantity  = parseInt(quantityInput.value, 10) || 0;
            const variantId = quantityInput.getAttribute('data-quantity-variant-id');
            const line = parseInt(quantityInput.getAttribute('data-index'), 10);
            if (!variantId) return;

            clearTimeout(this._updateTimer);
            this._updateTimer = setTimeout(() => {
                 this.updateQuantity(variantId, quantity, Number.isFinite(line) ? line : null)
                    .then(() => this.refreshCartPartials())
                    .catch(err => console.error('Update qty error', err));
            }, 400);
        });

        this.addEventListener('click', (e) => {
            const addUpsellButton       = e.target.closest('.add-upsell--button');
            const addUpgradeButton      = e.target.closest('.add-upgrade--button');
            const openUpsellPopupButton = e.target.closest('.popup-upsale--opener');

            if (addUpgradeButton) {
                e.preventDefault();

                if (this._adding) return;

                const upgradeBlock = addUpgradeButton.closest('.cart-upgrade');
                if (!upgradeBlock) return;

                const variantId = upgradeBlock.dataset.upgradeVariantId;
                if (!variantId) return;

                this._adding = true;
                addUpgradeButton.setAttribute('disabled', 'disabled');

                this.addUpsaleItem(variantId)
                    .then(() => this.refreshCartPartials())
                    .catch(err => console.error('Cart upgrade error', err))
                    .finally(() => {
                        this._adding = false;
                        addUpgradeButton.removeAttribute('disabled');
                    });

                return;
            }

            if (addUpsellButton) {
                e.preventDefault();

                if (this._adding) return;

                const upsellItem = addUpsellButton.closest('.upsell-list__item');
                if (!upsellItem) return;

                const variantId = upsellItem.dataset.upsellVariantId;
                if (!variantId) return;

                this._adding = true;
                addUpsellButton.setAttribute('disabled', 'disabled');

                this.addUpsaleItem(variantId)
                    .then(() => {
                        upsellItem.querySelector('.upsell-item__popup.open')?.classList.remove('open');
                        return this.refreshCartPartials();
                    })
                    .catch(err => console.error('Cart add error', err))
                    .finally(() => {
                        this._adding = false;
                        addUpsellButton.removeAttribute('disabled');
                    });

                return;
            }

            if (openUpsellPopupButton) {
                e.preventDefault();
                const upsellItem = openUpsellPopupButton.closest('.upsell-list__item');
                upsellItem?.querySelector('.upsell-item__popup')?.classList.add('open');
                return;
            }

            if (e.target.closest('.upsell-item__popup--close') || e.target.closest('.upsell-item__popup.open')) {
                e.preventDefault();
                const popup = e.target.closest('.upsell-item__popup');
                popup?.classList.remove('open');
            }
        });

        this.querySelector('#custom-cart-overlay')?.addEventListener('click', this.close.bind(this));
        document.addEventListener('cart::open', () => this.open());
        document.addEventListener('cart::request-render', () => {
            this.refreshCartPartials();
        });

        let checkoutBtn = this.querySelector('.cart__checkout-button');
        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', () => {
                if(typeof clarity === "function"){
                    clarity("set", "begin_checkout_id", "id_" + window.themeInfo.id);
                    clarity("event", "begin_checkout_id_" + window.themeInfo.id);
                    window.dataLayer.push({
                        event: "begin_checkout_id_" + window.themeInfo.id,
                    });
                    console.log(window.dataLayer)
                }
            });
        }
    }

    open(){
        this.classList.add('open');
        if(typeof clarity === "function"){
            clarity("set", "show_cart_id", "id_" + window.themeInfo.id);
            clarity("event", "show_cart_id_" + window.themeInfo.id);
            window.dataLayer.push({
                event: "show_cart_id_" + window.themeInfo.id,
            });
            console.log(window.dataLayer)
        }
    }

    close(){
        this.classList.remove('open');
        this.querySelectorAll('.upsell-item__popup')?.forEach(p => p.classList.remove('open'));
    }

    async refreshCartPartials() {
        const partsSelectors = {
            content: '.custom-cart__content',
            totals:  '.subtotal-block',
            button:  '.cart__ctas',
            payment: '.custom-cart__payment-block',
            review:  '.custom-cart__review-block'
        };

        const sections = ['section-custom-cart', 'cart-icon-bubble'];
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || window.location.pathname || '/';
        const url  = `${root}?sections=${sections.join(',')}`;

        let data;
        try {
            const res = await fetch(url, { headers: { 'Accept': 'application/json' }, method: 'GET' });
            if (!res.ok) throw new Error(`Sections fetch ${res.status}`);
            data = await res.json();
        } catch (e) {
            console.warn('[sections] JSON fail, fallback to section_id:', e);
        }


        const cartHTML = data?.['section-custom-cart'];
        if (cartHTML) {
            const cartDoc = new DOMParser().parseFromString(cartHTML, 'text/html');
            Object.values(partsSelectors).forEach(sel => {
                const nextEl = cartDoc.querySelector(sel);
                const curEl  = this.querySelector(sel);
                if (nextEl && curEl) curEl.replaceWith(nextEl.cloneNode(true));
            });
        }

        const counterBlock = data?.['cart-icon-bubble'];
        if (counterBlock) {
            const target = document.querySelector( '#cart-icon-bubble');
            if (target) {
                const parsedBlock = new DOMParser().parseFromString(counterBlock, 'text/html');
                const updatedEl = parsedBlock.body.firstElementChild
                target.innerHTML = updatedEl ? updatedEl.innerHTML : '';
            } else {
                console.warn('Counter target not found');
            }
        }

        this.validateFreeFromCartDoc(cartHTML)
    }

    validateFreeFromCartDoc(data) {
        const cartData = new DOMParser().parseFromString(data, 'text/html');
        const script = cartData.querySelector('.cart-custom-data');
        if (!script) return;

        const giftData = JSON.parse(script.textContent || '{}');
        const rules = Array.isArray(giftData.cart_products) ? giftData.cart_products : [];

        const nonGiftIds = new Set(
            Array.from(cartData.querySelectorAll('[data-cart-item-id]:not(.gift--item)'))
                .map(el => String(el.getAttribute('data-cart-item-id')))
                .filter(Boolean)
        );

        const cartGiftIds = Array.from(cartData.querySelectorAll('[data-cart-item-id].gift--item'))
            .map(el => String(el.getAttribute('data-cart-item-id')))
            .filter(Boolean);

        if (cartGiftIds.length === 0) return;

        const updates = {};

        if (rules.length === 0 || nonGiftIds.size === 0) {
            cartGiftIds.forEach(id => { updates[id] = 0; });
        } else {
            cartGiftIds.forEach(giftId => {
                const isJustified = rules.some(rule => {
                    const ruleGifts = (rule.gifts || []).map(v => String(v));
                    const mainId = String(rule.main_product);
                    return ruleGifts.includes(giftId) && nonGiftIds.has(mainId);
                });

                if (!isJustified) updates[giftId] = 0;
            });
        }

        if (Object.keys(updates).length > 0) {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates })
            }).then(() => this.refreshCartPartials());
        }
    }

    addUpsaleItem(variantId) {
        const payload = { id: Number(variantId), quantity: 1 };
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
        }).then(res => {
            if (!res.ok) throw new Error('Cart add error');
            return res.json();
        });
    }

    updateQuantity(variantId, quantity, line) {
        const useLine = Number.isFinite(line);
        const endpoint = useLine ? '/cart/change.js' : '/cart/update.js';
        const payload = useLine
            ? { line, quantity }
            : { updates: { [variantId]: quantity } };

        return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
        }).then(res => {
            if (!res.ok) throw new Error('Cart update error');
            return res.json();
        });
    }
}

customElements.define('custom-cart', CustomCart);

function triggerCartOpen() {
    document.dispatchEvent(new Event('cart::open'));
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a.cart--opener').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            triggerCartOpen();
        });
    });
});